import React from "react";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import { withTranslation } from "react-i18next";
import Button from "components/Button";
import styles from "../../OfficePolicyManagement/OfficePolicyManagement.module.scss";

const DeleteReminderModal = ({
  t,
  isModalOpen,
  keyName,
  closeModal,
  deleteReminderItem,
  title,
}) => {
  return (
    <Modal
      isOpen={!!isModalOpen}
      toggle={closeModal}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <div className={styles.delete_task_modal}>
          <Text size="25px" weight="500" color="#111B45">
            {title}
          </Text>
          <Text size="16px" weight="300" color="#535B5F" marginTop="11px">
            {t("patientAppointmentMembers.deleteReminderMsg")}
          </Text>
          <div className={styles.delete_task_btn_wrapper}>
            <Button
              title="save"
              onClick={() => deleteReminderItem(keyName, isModalOpen)}
              className={styles.delete_task_btn}
            >
              {" "}
              {t("patientAppointmentMembers.yesConfirm")}
            </Button>
            <Button
              borderedSecondaryNew
              title="cancel"
              onClick={closeModal}
              className={styles.delete_task_btn}
            >
              <span>{t("patientAppointmentMembers.cancel")}</span>
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(DeleteReminderModal);
